import React from "react"
import { Box, Container, Grid } from "@mui/material"

import SEO from "@secureo/common/components/SEO"
import { CustomAppProps } from "pages/_app"
import BreadCrumbs, { BreadCrumb } from "components/BreadCrumbs"

import { helpCenterAncestorBreadCrumbs } from "./index"

const HowToMeasureCylinders = ({ asPath, locale }: CustomAppProps) => {
	const currentPath: BreadCrumb = {
		href: "/help/how-to-measure-cylinders",
		label: "Zylinder messen",
	}

	return (
		<>
			<SEO asPath={asPath} appendLocalizedShopNameWithPipe title="Zylinder messen" />
			<BreadCrumbs
				locale={locale}
				currentPath={currentPath}
				ancestors={helpCenterAncestorBreadCrumbs}
			/>
			<Box my={5} pb={5}>
				<Container>
					<div
						style={{
							color: "#4691CE",
							textTransform: "uppercase",
							fontSize: 13,
						}}
					>
						<strong>Hilfe</strong>
					</div>
					<Box mb={2}>
						<h1 style={{ margin: 0 }}>Zylinder messen</h1>
					</Box>
					<Box>
						<Grid container spacing={3}>
							<Grid item xs={12} md={4}>
								<Box mt={3}>
									<img
										alt="eingebauter-zustand"
										src="https://res.cloudinary.com/safehero/image/upload/v1573210742/ProductDetailPage/eingebauter-zustand.svg"
										style={{ width: "100%", maxHeight: "200px" }}
									/>
								</Box>
							</Grid>
							<Grid item xs={12} md={8}>
								<Box mt={3}>
									<strong>Im eingebauten Zustand:</strong>
								</Box>
								<p>
									Für den perfekten Sitz: Messen Sie vor dem Kauf die Abstände vom
									Mittelpunkt der Schraube, die Ihren Zylinder fixiert, bis zur
									äußeren <strong>(A)</strong> und inneren Seite{" "}
									<strong>(B)</strong> der Tür.
								</p>
								<p>
									Beim eingebauten Zylinder misst man ausgehend von der Mitte des
									in der Tür eingebauten Schlosses. Dazu orientiert man sich am
									Besten an der Zylinderbefestigungsschraube und misst bis an die
									Enden des Zylinders auf der Innen- und Außenseite. So ergeben
									sich zwei Maße, einmal Innen bis zur Mitte des Schlosses und
									einmal von Außen bis zur Mitte des Schlosses. Die Zylinderlängen
									beginnen auf jeder Seite bei 30 bzw. 31 mm und sind in 5 mm
									Schritten bis maximal 85 bzw 86 mm erhältlich.
								</p>
							</Grid>
						</Grid>

						<Grid container spacing={3}>
							<Grid item xs={12} md={8}>
								<Box mt={3}>
									<strong>Im ausgebauten Zustand:</strong>
								</Box>
								<p>
									Für eine exakte Messung empfehlen wir, den bestehenden Zylinder
									auszubauen und abzumessen. Dazu stecken Sie einen Schlüssel an
									und drehen die Zylinderbefestigungsschraube heraus. Jetzt kann
									der Zylinder herausgezogen werden. Sollte sich die Schließnase
									verhaken, drehen Sie bitte den Schlüssel, bis sich der Zylinder
									sanft entfernen lässt.{" "}
								</p>
								<p>
									Nun können Sie den Zylinder, ausgehend vom Befestigungsloch in
									der Mitte, auf beiden Seiten abmessen. Wenn beide Längen
									feststehen, können Sie Ihren neuen Zylinder bestellen.
								</p>
							</Grid>
							<Grid item xs={12} md={4}>
								<Box my={3}>
									<img
										alt="ausgebauter-zustand"
										src="https://res.cloudinary.com/safehero/image/upload/v1573210561/ProductDetailPage/ausgebauter-zustand.svg"
										style={{ width: "100%" }}
									/>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>
		</>
	)
}

export default HowToMeasureCylinders
